// Ported from vlookup-dramatic/app/home-reveal.tsx by scripts/revamp/port-design.js
import React, { useEffect, useRef, useState } from "react";
import { cn } from "../../lib/utils";
/*
 * Lightweight scroll-reveal wrapper. SSR (and no-JS) renders content fully
 * visible; on mount, elements still below the fold are hidden and revealed
 * by an IntersectionObserver. Respects prefers-reduced-motion.
 */
export function HomeReveal({ children, className, delay = 0, }) {
    const ref = useRef(null);
    const [hidden, setHidden] = useState(false);
    const [shown, setShown] = useState(false);
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
            return;
        if (typeof IntersectionObserver === "undefined")
            return;
        // Already on screen? Never hide it.
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92)
            return;
        setHidden(true);
        const io = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setShown(true);
                io.disconnect();
            }
        }, { rootMargin: "0px 0px -8% 0px" });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return (<div ref={ref} style={delay ? { transitionDelay: `${delay}ms` } : undefined} className={cn("transition-[opacity,transform] duration-700 ease-out", hidden && !shown && "translate-y-8 opacity-0", className)}>
      {children}
    </div>);
}
